var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.73926 1.75C4.10176 1.75 2.77051 3.08125 2.77051 4.71875C2.77051 6.325 4.02676 7.625 5.66426 7.68125C5.71426 7.675 5.76426 7.675 5.80176 7.68125C5.81426 7.68125 5.82051 7.68125 5.83301 7.68125C5.83926 7.68125 5.83926 7.68125 5.84551 7.68125C7.44551 7.625 8.70176 6.325 8.70801 4.71875C8.70801 3.08125 7.37676 1.75 5.73926 1.75Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91289 9.34844C7.16914 8.18594 4.32539 8.18594 2.56914 9.34844C1.77539 9.87969 1.33789 10.5984 1.33789 11.3672C1.33789 12.1359 1.77539 12.8484 2.56289 13.3734C3.43789 13.9609 4.58789 14.2547 5.73789 14.2547C6.88789 14.2547 8.03789 13.9609 8.91289 13.3734C9.70039 12.8422 10.1379 12.1297 10.1379 11.3547C10.1316 10.5859 9.70039 9.87344 8.91289 9.34844Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.6066 5.08341C12.7066 6.29591 11.8441 7.35841 10.6504 7.50216C10.6441 7.50216 10.6441 7.50216 10.6379 7.50216H10.6191C10.5816 7.50216 10.5441 7.50216 10.5129 7.51466C9.90664 7.54591 9.35039 7.35216 8.93164 6.99591C9.57539 6.42091 9.94414 5.55841 9.86914 4.62091C9.82539 4.11466 9.65039 3.65216 9.38789 3.25841C9.62539 3.13966 9.90039 3.06466 10.1816 3.03966C11.4066 2.93341 12.5004 3.84591 12.6066 5.08341Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8555 10.869C13.8055 11.4752 13.418 12.0002 12.768 12.3565C12.143 12.7002 11.3555 12.8627 10.5742 12.844C11.0242 12.4377 11.2867 11.9315 11.3367 11.394C11.3992 10.619 11.0305 9.87525 10.293 9.2815C9.87422 8.95025 9.38672 8.68775 8.85547 8.494C10.2367 8.094 11.9742 8.36275 13.043 9.22525C13.618 9.68775 13.9117 10.269 13.8555 10.869Z",
    fill: "#333448",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profile-user.296cf5e295b9a21eb317620fe7bea1a7.svg";
export { ForwardRef as ReactComponent };